import React from 'react'
import { TrackedCTA } from 'components/CallToAction'
import { prepareData } from 'utils/googleData'

export const PricingCTA = (props: { dark?: boolean; className?: string }): JSX.Element => {
    const {
        enable,
        eventName = 'clicked to view pricing',
        eventType = 'homepage',
        dark = false,
        text = 'View pricing',
        type = 'secondary',
        width,
        url = '/pricing',
        event,
        subtitle,
        description,
        cta,
        direction,
        style: className = '',
        gatsbyImage,
        features,
        gatsbyImage2,
    } = prepareData({ props })
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    const darkClasses = `${className} text-[15px] group justify-center font-semibold text-white py-2 px-3 rounded-sm hover:!text-white bg-white/0 border border-solid border-white/20 hover:bg-white/30 inline-flex space-x-2 items-center relative active:top-[0.5px] active:scale-[.98] !w-full md:!w-44 shadow-xl`
    const lightClasses = `${className} text-[15px] group justify-center font-semibold py-2 px-3 rounded-sm inline-flex space-x-2 items-center relative active:top-[0.5px] active:scale-[.98]  !w-full md:!w-44 shadow-xl`

    return (
        <TrackedCTA
            event={{
                name: eventName,
                type: eventType,
            }}
            direction={direction}
            type={type}
            to={url}
            className={dark ? darkClasses : lightClasses}
        >
            <span>{text}</span>
        </TrackedCTA>
    )
}
